import {BrandBase} from '../BrandBase';
import {createMicrositeTheme} from '../MicrositeTheme';

export const sextyNineBase: BrandBase = {
  id: `sextyNine`,
  domain: `sextynine.com`,
  email: `support@sextynine.com`,
  theme: `green`,
  backgroundId: `playful`,
  adsenseId: null,
  micrositeTheme: createMicrositeTheme({
    id: `sextyNine`,
    name: `Sexty Nine Microsite`,
    palette: {
      primary: `#00a884`,
      secondary: `#0f766e`,
      accent: `#22d3ee`,
    },
    gradients: {
      hero: `linear-gradient(135deg, #0f766e, #00a884)`,
      sectionLight: `linear-gradient(135deg, rgba(236, 253, 245, 0.96), rgba(209, 250, 229, 0.92))`,
      sectionDark: `linear-gradient(160deg, #012b23, #064e3b 45%, #011a16 90%)`,
      primaryCta: `linear-gradient(120deg, #10b981, #14b8a6 50%, #2dd4bf 100%)`,
    },
    ctas: {
      primary: {
        background: `linear-gradient(120deg, #10b981, #14b8a6 50%, #2dd4bf 100%)`,
        glow: `rgba(16, 185, 129, 0.45)`,
        shadow: `0 32px 70px rgba(16, 185, 129, 0.4)`,
      },
    },
  }),
  hostRedirects: {
    'www.sextynine.com': `sextynine.com`,
  },
  manifest: {
    name: `Sexty Nine Connect - Anonymous Sexting | No Registration Required`,
    short_name: `69Connect`,
    description: `Real-time anonymous sexting platform. Connect instantly without barriers or registration hassles.`,
    theme_color: `#1a1a1a`,
    background_color: `#0a0a0a`,
    display: `standalone`,
    orientation: `portrait`,
    scope: `/`,
    start_url: `/`,
    icons: [],
  },
  canonical: {
    prod: `https://sextynine.com`,
    uat: `https://dev.sextynine.com`,
    local: `http://localhost:5173`,
    localdev: `http://localhost:5173`,
    localnative: `http://localhost:5173`,
  },
  favicon: `/logo-square.png`,
  seo: {
    keywords: `anonymous sexting, sexting app, sexting platform, real-time messaging, instant connect, anonymous platform, barrier-free chat, quick messaging, seamless communication, SixtyNine Connect`,
    author: `SixtyNine Connect`,
  },
  social: {
    title: `Sexty Nine Connect - Anonymous Sexting`,
    image: `/icon.png`,
  },
};
